import Vue from 'vue'
import Router from 'vue-router'
import getCoupon from './views/getCoupon.vue'
import scheme from './views/scheme.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/getCoupon'
    },
    {
      path: '/getCoupon',
      name: 'getCoupon',
      component: getCoupon
    },
    {
      path: '/scheme',
      name: 'scheme',
      component: scheme
    },
    // {
    //   path: '/getCouponLogin',
    //   name: 'getCouponLogin',

    //   component: function () {
    //     return import('./views/getCouponLogin.vue')
    //   }
    // }
  ]
})
